import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseApi';

export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Organisations',
    'Payouts',
    'VirtualAccounts',
    'Orders',
    'Payments',
    'Stats',
    'Transactions',
    'Reports',
    'BatchTemplates',
    'Batches',
    'Currencies',
    'PayoutDraft',
    'BusinessUnits',
    'Users',
    'FeatureFlags',
    'WithdrawalRequests',
    'Crypto',
    'Statements',
    'InterAccountMovements'
  ],
  endpoints: () => ({})
});
